export type License = {
  id: string
  userId: string
  state: string
  licenseType: string
  expiry: string | null
  termLabel: string | null
  termStart: string | null
  termEnd: string | null
  licenseNumber?: string
  documentUrl?: string
  contentType?: string
  uploadedAt?: string
  orgId?: string
  orgType?: string
  enteredBy?: string
  isExempt?: boolean
  status?: LicenseStatus
  createdAt: string
  updatedAt: string
}

export type LicenseStatus = 'valid' | 'expired' | 'exempt'

export const LICENSE_TYPES = [
  'state_hunting',
  'federal_duck_stamp',
  'hal',
  'nr_game_bird',
  'wildlife_habitat_cert',
  'game_bird_licence',
  'federal_mgbh_permit',
  'cwhc_stamp',
] as const

export type LicenseType = (typeof LICENSE_TYPES)[number]

export const LICENSE_TYPE_LABELS: Record<LicenseType, string> = {
  state_hunting: 'State Hunting',
  federal_duck_stamp: 'Federal Duck Stamp',
  hal: 'Hunting, Angling & Trapping Licence (HAL)',
  nr_game_bird: 'Non-Resident Game Bird',
  wildlife_habitat_cert: 'Wildlife Habitat Certificate',
  game_bird_licence: 'Game Bird Licence',
  federal_mgbh_permit: 'Federal MGBH Permit',
  cwhc_stamp: 'CWHC Stamp',
}
